import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ProductsBiocatchEnum, StepBiocatchEnum } from 'src/app/shared/enums/biocatchContext.enum';
import { OpEnum } from 'src/app/shared/enums/op.enum';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { BioCatchService } from 'src/app/shared/services/external/biocatch/biocatch.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { RequestService } from 'src/app/shared/services/request/request-onboarding.service';
var SecondHeadlineComponent = /** @class */ (function () {
    function SecondHeadlineComponent(copyService, formBuilder, headerService, navigationService, bitacoraService, abreCuentasService, requestService, biocatchService, parameterService) {
        this.copyService = copyService;
        this.formBuilder = formBuilder;
        this.headerService = headerService;
        this.navigationService = navigationService;
        this.bitacoraService = bitacoraService;
        this.abreCuentasService = abreCuentasService;
        this.requestService = requestService;
        this.biocatchService = biocatchService;
        this.parameterService = parameterService;
        this.headerService.show(true, true, true);
        this.formGroup = this.formBuilder.group({});
    }
    SecondHeadlineComponent.prototype.ngOnInit = function () {
        var preLoginOnly = this.biocatchService.isEvidenteCase();
        var product = this.abreCuentasService.getproductSelected().product_code;
        if (product !== ProductsBiocatchEnum.VIV) {
            this.biocatchService.changeContext(StepBiocatchEnum.configuracion, product, this.biocatchService.isVivCn(product), preLoginOnly);
        }
        this.formGroup = new FormGroup({
            selection_second_headline: new FormControl('', Validators.required),
        });
        this.listSecondLine = [{
                label: this.copyService.copies.second_headline.second_yes,
                value: true,
            },
            {
                label: this.copyService.copies.second_headline.second_no,
                value: false,
            }];
        this.restrictiveList();
    };
    SecondHeadlineComponent.prototype.next = function () {
        this.abreCuentasService.setSecondHeadline({
            has_second_headline: this.formGroup.controls.selection_second_headline.value,
            has_incomes_second_headline: null,
        });
        var nextStep = this.formGroup.controls.selection_second_headline.value ? '200' : '201';
        var bitacoraEvent = "second headline_" + (nextStep === '200' ? 'yes' : 'no');
        this.bitacoraService.saveDataInBitacora(bitacoraEvent);
        this.navigationService.nextStep(nextStep);
    };
    SecondHeadlineComponent.prototype.restrictiveList = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var restrictive_params, data_user, fullName, body;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        restrictive_params = this.parameterService.getSetting(OpEnum.RESTRICTIVE_PARAMETERS);
                        data_user = this.abreCuentasService.getDocumentInfo();
                        fullName = data_user.firstname + " " + data_user.middlename + " " + data_user.primary_lastname + " " + data_user.second_lastname;
                        body = {
                            data: {
                                client_name: fullName,
                                document: {
                                    number: data_user.document_number,
                                },
                                user_name: restrictive_params.user_name,
                                employee_id: restrictive_params.employee_id,
                                application: restrictive_params.application,
                                priority: restrictive_params.priority,
                                reference_type: restrictive_params.reference_type,
                                transaction_type: restrictive_params.transaction_type,
                            },
                        };
                        return [4 /*yield*/, this.requestService.getRestrictiveList(body).then(function (res) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                var data;
                                return tslib_1.__generator(this, function (_a) {
                                    data = {
                                        list_query_status: {
                                            status_code: res.data.status_code,
                                        },
                                    };
                                    this.abreCuentasService.setProspectResponse(data);
                                    if (res.data.status_code === '5') {
                                        this.navigationService.navigateToGeneralInformation('107');
                                        return [2 /*return*/];
                                    }
                                    return [2 /*return*/];
                                });
                            }); }).catch(function () { return _this.navigationService.navigateToGeneralInformation('107'); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return SecondHeadlineComponent;
}());
export { SecondHeadlineComponent };
